<template>
  <div class="milestone-content">
    <div class="content-header">
      <img
        class="section-top"
        src="@/assets/imgs/act/wc2026/section-top.png"
        alt="section-title-icon"
      />
      <img class="section-title" :src="title" alt="section-title" />
      <div class="sub-title">{{ state.subTitle }}</div>
    </div>

    <!-- 统计概览 -->
    <div class="stats-row flex-center">
      <div
        class="stat-item flex-center btn"
        :class="{ active: tab === 1 }"
        @click="changeTab(1)"
      >
        <!-- <div class="stat-value">{{ state.data.totalCheerCount }}</div> -->
        <div class="stat-label">{{ $t("wc2026.milestone.totalCheer") }}</div>
      </div>
      <div
        class="stat-item flex-center btn"
        :class="{ active: tab === 2 }"
        @click="changeTab(2)"
      >
        <!-- <div class="stat-value highlight">{{ state.data.winCheerCount }}</div> -->
        <div class="stat-label ">{{ $t("wc2026.milestone.winCheer") }}</div>
      </div>
    </div>

    <div class="two-col">


      <!-- 里程碑 -->
      <div class="milestone-section" >
        <div class="line-wrap">
          <div class="line-container">
            <div class="line-left"></div>
            <div class="line-right">
              <div
                class="line-item"
                v-for="item in state.data.currentMilestones"
                :key="item.milestoneId"
              >
                <div
                  class="line-item-icon-wrap flex-center"
                >
                  <div
                  class="line-item-icon"
                    :class="getLineItemIconClass(item)"
                  ></div>
                </div>
                <div
                  class="line-item-name"
                  :class="item.status != 0 ? 'active' : ''"
                >
                  {{
                    $t("wc2026.milestone.betTarget").replace(
                      "_n",
                      item.targetCount,
                    )
                  }}
                </div>
                <div class="milestone-item" :class="getMsBtnClass(item)">
                  <div class="award-icon-wrap flex-center">
                    <img :src="getItemIcon(item.propInfo.propId, locale)" :class="`award-icon icon-${item.propInfo.propId}`" />
                  </div>
                  <div class="award-name">
                   {{ $t(`wc2026.item.id_${item.propInfo.propId}`) }}*{{ item.propInfo.propCount }}
                  </div>
                  <div
                    class="ms-btn flex-center"
                    :class="getMsBtnClass(item)"
                    :disabled="item.status !== 1"
                    @click="handleReceive(item)"
                  >
                    {{ getMsBtnText(item) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { reactive, watch, computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { toastService } from "@/utils/toastService";
import WcApi from "@/config/wcActApi";
import { getItemIcon } from '@/views/act/wc2026/item'
import { useLog } from "@/composables/useActLog";
const log = useLog();
import titleEn from "@/assets/imgs/act/wc2026/milestone/titleen.png";
import titleZh from "@/assets/imgs/act/wc2026/milestone/titlezh.png";

import titleVi from "@/assets/imgs/act/wc2026/milestone/titlevi.png";
import titleTh from "@/assets/imgs/act/wc2026/milestone/titleth.png";
import titleId from "@/assets/imgs/act/wc2026/milestone/titleid.png";
import { milestoneData } from './const';

const _milestoneData = JSON.parse(JSON.stringify(milestoneData));
const { t } = useI18n();
const store = useStore();

const tab = ref(1);
const locale = useI18n().locale
const title = computed(() => {
  switch (locale.value) {
    case "tw":
      return titleZh;
    case "en":
      return titleEn;
    case "vi":
      return titleVi;
    case "th":
      return titleTh;
    case "id":
      return titleId;
    case "hk":
      return titleZh;
    default:
      return titleEn;
  }
});

const state = reactive({
  data: milestoneData,
});

const changeTab = (val) => {
  tab.value = val;
};
watch(() => [tab.value,state.data], (val) => {
  if (val[0] === 1) {
    state.data.currentMilestones = state.data.betMilestones;
    state.data.currentCount = state.data.totalCheerCount;
    state.subTitle = t("wc2026.milestone.subTitleTotal");
  } else {
    state.data.currentMilestones = state.data.winMilestones;
    state.data.currentCount = state.data.winCheerCount;
    state.subTitle = t("wc2026.milestone.subTitleWin");
  }
  state.data.currentMilestones.forEach(item => {
    if(typeof item.propInfo === 'string') {
      item.propInfo = JSON.parse(item.propInfo)[0];
      console.log('item.propInfo', item.propInfo);
    }

  });
  
}, {
  immediate: true,
});

const getMsBtnClass = (item) => {
  if (item.status === 1) return "can-receive";
  if (item.status === 2) return "received";
  return "not-reach";
};

const getMsBtnText = (item) => {
  if (item.status === 0) return t("wc2026.notReach");
  if (item.status === 1) return t("wc2026.canReceive");
  return t("wc2026.received");
};

const getLineItemIconClass = (item) => {
  if (item.lineStatus === 2) return "line-item-icon-current";
  if (item.lineStatus === 1) return "line-item-icon-completed";
  return "line-item-icon-not-reach";
};

const handleReceive = async (item) => {
  if (item.status !== 1) return;
  try {
    await WcApi.receiveMilestone({ milestoneId: item.milestoneId });

    item.status = 2;
    toastService.showSmall(t("wc2026.receiveSuccess"));
    if (item.milestoneType === 1) {
      log.track("act_worldcup_progress_rewards", {
        v1: JSON.stringify(JSON.parse(_milestoneData.betMilestones.find(item1 => item1.milestoneId === item.milestoneId).propInfo).map((item2)=> {
          return {
            id: item2.propId,
            name: item2.propName,
            count: item2.propCount,
          }
        })),
        v2: item.targetCount,
      });
    } else if (item.milestoneType === 2) {
      log.track("act_worldcup_correct_rewards", {
        v1: JSON.stringify(JSON.parse(_milestoneData.winMilestones.find(item1 => item1.milestoneId === item.milestoneId).propInfo).map((item2)=> {
          return {
            id: item2.propId,
            name: item2.propName,
            count: item2.propCount,
          }
        })),
        v2: item.targetCount,
      });
    }
  } catch (e) {
    console.error(e);
  }
};

const loadData = async () => {
  try {
    const res = await WcApi.getMilestoneList({});
    state.data = res;
    // 计算lineStatus：2=当前档位（已达到本档但未达下一档），1=已完成（已超过下一档），0=未到达
    const calcLineStatus = (milestones, count) => {
      milestones.forEach((item, index) => {
        const nextItem = milestones[index + 1];
        if (count >= item.targetCount) {
          if (nextItem && count < nextItem.targetCount) {
            item.lineStatus = 2;
          } else if (!nextItem) {
            item.lineStatus = 2;
          } else {
            item.lineStatus = 1;
          }
        } else {
          item.lineStatus = 0;
        }
      });
    };
    // calcLineStatus(state.data.betMilestones, 180);
    // calcLineStatus(state.data.winMilestones, 40);
    calcLineStatus(state.data.betMilestones, state.data.totalCheerCount);
    calcLineStatus(state.data.winMilestones, state.data.winCheerCount);


  } catch (e) {
    console.error(e);
  }
}

watch(() => store.state.actUserInfo, (newVal) => {
  if (newVal && newVal.token) {
    loadData();
  }
}, {
  immediate: true,
});
</script>

<style lang="less" scoped>
.milestone-content {
  .content-header {
    margin-bottom: 24px;

    .section-title {
      height: 47px;
      width: auto;
      margin: 0 auto;
      display: block;
    }
    .sub-title {
      margin: 25px 0;
      text-align: center;
    }
  }
}

.stats-row {
  margin-bottom: 60px;
  .stat-item {
    flex: 1;
    text-align: center;
    width: 255px;
    height: 89px;

    background-image: url("~@/assets/imgs/act/wc2026/milestone/btn-big.png");
    &.stat-item-right {
      margin-left: 225px;
      background-image: url("~@/assets/imgs/act/wc2026/milestone/btn-big-acitve.png");
      color: #fff;
    }
    &.active {
      background-image: url("~@/assets/imgs/act/wc2026/milestone/btn-big-acitve.png");
    }
    .stat-value {
    }

    .stat-label {
    }
  }

  .stat-divider {
    width: 1px;
    background: rgba(255, 255, 255, 0.08);
  }
}



.milestone-section {
  .ms-section-title {
    font-size: 22px;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.5);
    margin-bottom: 14px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }
}

.milestone-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.milestone-item {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 14px 16px;
  .award-icon {
    width: 77px;
    height: auto;
  }
  .award-name {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    flex: 1;
    text-align: center;
  }
  .ms-info {
    flex: 1;
    min-width: 0;

    .ms-name {
      font-size: 20px;
      color: #e0e6f0;
      margin-bottom: 8px;
    }

    .ms-progress-bar {
      height: 6px;
      background: rgba(255, 255, 255, 0.08);
      border-radius: 3px;
      overflow: hidden;
      margin-bottom: 5px;

      .ms-progress-fill {
        height: 100%;
        background: #4caf50;
        border-radius: 3px;
        transition: width 0.4s;

        &.win {
          background: #ffc107;
        }
      }
    }

    .ms-progress-text {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.3);
    }
  }

  .ms-btn {
    flex-shrink: 0;
    padding: 8px 18px;
    border: none;
    border-radius: 8px;
    font-size: 17px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.2s;
    text-align: center;

    &.can-receive {
      background: #4caf50;
      color: #fff;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }

    &.received {
      background: rgba(255, 255, 255, 0.06);
      color: rgba(255, 255, 255, 0.25);
      cursor: not-allowed;
    }

    &.not-reach {
      background: rgba(255, 255, 255, 0.03);
      color: rgba(255, 255, 255, 0.15);
      cursor: not-allowed;
    }
  }
}
.milestone-section {
  margin: auto;
  padding-left: 44px;
  .line-wrap {

    .line-container {
      position: relative;


      .line-left {
        position: absolute;
        width: 18px;
        top: 0;
        left: 19px;
        top: 36px;
        bottom: 0;
        background-image: url("~@/assets/imgs/act/wc2026/milestone/line.png");
        background-position: top center;
        background-size: 100% auto;
      }
      .line-right {
        position: relative;
        z-index: 1;
        .line-item {
          display: flex;
          align-items: center;
          width: auto;
          margin-bottom:9px;
          //justify-content:center;
          .line-item-icon-wrap {
            height: 56px;
            width: 56px;
          }
          .line-item-icon {
            &.line-item-icon-current {
              width: 56px;
              height: 56px;
              background-image: url("~@/assets/imgs/act/wc2026/milestone/checked.png")

            }
            &.line-item-icon-completed {
              width: 23px;
              height: 23px;
              background-image: url("~@/assets/imgs/act/wc2026/milestone/active.png")

            }
            &.line-item-icon-not-reach {
              width: 23px;
              height: 22px;
              background-image: url("~@/assets/imgs/act/wc2026/milestone/uncheck.png");
            }
          }
          .line-item-name {
            font-size: 20px;
            font-weight: bold;
            color: #747474;
            width: 50px;
            margin-right: 12px;
            text-align: center;
            &.active {
              color: #d85b00;
            }
          }
          .milestone-item {
            width: 530px;
            height: 101px;
            padding-left:47px;
            padding-right:14px;
            display: flex;
            align-items: center;
            
            background-image: url("~@/assets/imgs/act/wc2026/milestone/un-revice-bg.png");
            &.can-receive {
              background-image: url("~@/assets/imgs/act/wc2026/milestone/can-revice-bg.png");
            }
            &.received {
              background-image: url("~@/assets/imgs/act/wc2026/milestone/reviced-bg.png");
            }
            .award-icon-wrap {
              width: 77px;

              .award-icon {
                width: 77px;
                height: auto;
                &.icon-20400904 {
                  width: 23px;
                  height: 92px;
                }
              }
            }

            .award-name {
              font-size: 16px;
              font-weight: bold;
              color: #fff;
              text-align: center;
              padding: 0 12px;
              flex: 1;
            }
            .ms-btn {
              background-image: url("~@/assets/imgs/act/wc2026/milestone/btn-gray.png");
              color:#fff;
              width: 119px;
              height: 42px;
              font-weight: bold;
              &.can-receive {
                color:#1853D7;
                background-image: url("~@/assets/imgs/act/wc2026/milestone/can-revice-btn.png");
              }
            }
          }
        }

      }
    }
  }
}
</style>
